import styled, { css } from "styled-components/macro";
import { Col, Label, Form } from "reactstrap";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import { Button, Tooltip } from "@material-ui/core";
import { tooltipClasses } from "@mui/material";
import * as React from 'react'; 
import { Modal } from "reactstrap";
import { device } from "./constants";

// import { transform } from "@babel/core";

export const SpinnerContainer = styled.div`
    position: absolute;
    width: ${(props) => (props.width ? props.width : "85%")};
    height: ${(props) => (props.height ? props.height : "79vh")};
    top: ${(props) => (props.top ? props.top : "13%")};
    ${(props) => (props.left ? css`left: ${props.left};` : "")}
    z-index: 9999;
`;

export const ManageSecureConnect = styled.div``;
export const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    <span className='hello'>
      <Tooltip {...props} arrow classes={{ popper: className }} />
    </span>
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: 'silver',
    },
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 'none', // Adjust the value to your desired width
      fontSize: '13px',
      color: 'black',
      backgroundColor: 'white',
      border: 'solid 1px silver',
      textOverflow: 'ellipsis',
     
    },
  })); 

export const StyledForm = styled(Form)`
    .form-group:first-child {
        margin-bottom: 0;
    }
    .form-group {
        > div {
            margin-bottom: 1px;
            #network-name {
                width: 70%;
                margin-bottom: 5px;
            }
            span {
                svg {
                    margin-left: 6px;
                }
            }
        }
        div:first-child {
            label {
                margin-left: 15px;
            }
        }
        label.errortext {
            color: #d42d27 !important;
        }
    }
`;

export const HeaderLabelCol = styled(Col)`
    height: 29px;
    padding: 10px 0px 0px 14px;
    label {
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 600;
        color: #000;
    }
`;

export const CorrectAllError = styled.div`
    color: rgb(212, 45, 39);
    font-family: Lato;
    font-style: italic;
    border: 2px solid rgb(212, 45, 39);
    padding: 7px;
    position: absolute;
    right: 15px;
`;

export const ErrorIcon = styled(BsFillExclamationTriangleFill)`
    color: rgb(212,45,39);
    margin-right: 6px;
    font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
    margin-bottom: ${(props) => (props.marginbottom ? props.marginbottom : "3px")};
`;

export const ErrorLabel = styled(Label)`
    color: #d42d27;
    font-style: italic;
    font-size: 10px;
    font-family: Lato;
    font-weight: bolder;
    margin-left: 17px !important;
`;

export const ErrorContainer = styled.span`
    position: absolute;
    left: 0;
    top: 25px;
    width: ${ props => (props.width ? props.width :"100%") };
    svg {
        position: absolute;
        bottom: 20px;
        right: 25%;
    }
`;

export const StyledHRColumn = styled(Col)`
    width: 100%;
    margin: 0;
    padding: 0;
    margin-left: ${ props => (props.ml ? props.ml :"15px") };
    hr {
        background-color: rgb(102, 102, 102);
        border: none;
        height: 1px;
    }
`;

export const CloseButton = styled(Button)`
    background-color: #333333 !important;
    border-radius: 3px !important;
    border-color: #333333 !important;
    width: ${ props => (props.width ? props.width :"90px") };
    height: ${ props => (props.height ? props.height :"29px") };
    font-size: 13px !important;
    font-weight: normal !important;
    margin-left: ${ props => (props.ml ? props.ml :"5px") } !important;
    margin-right: ${ props => (props.mr ? props.mr :"5px") } !important;
    margin-top: ${ props => (props.mt ? props.mt :"5px") } !important;
    margin-bottom: ${ props => (props.mb ? props.mb :"5px") } !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    svg {
        margin-bottom: 2px;
        margin-right: 5px;
    }
`;

export const SaveButton = styled(Button)`
    background-color: ${ props => (props.primary ? "#2070cf" :"#333333") } !important;
    border-radius: 3px !important;
    border-color: ${ props => (props.primary ? "#61ae34" :"#333333") } !important;
    width: ${ props => (props.width ? props.width :"90px") };
    height: ${ props => (props.height ? props.height :"29px") };
    font-size: 13px !important;
    font-weight: normal !important;
    margin-left: ${ props => (props.ml ? props.ml :"15px") } !important;
    margin-right: ${ props => (props.mr ? props.mr :"10px") } !important;
    margin-top: ${ props => (props.mt ? props.mt :"0px") } !important;
    margin-bottom: ${ props => (props.mb ? props.mb :"0px") } !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    ${ props => (props.disabled ? css`
            background-color: ${ props => (props.primary ? "#9ebd8b" :"#bdbdbd") } !important;
            border-color: ${ props => (props.primary ? "#9ebd8b" :"#bdbdbd") } !important;
        ` : null)
    }

`;

export const DeleteIconWrapper = styled.div`
    width: 20px;
    height: auto;
    cursor: pointer;
    ${
        (props) => (props.disabled ? css`color: lightgray;` : "")
    }
    &:hover {
        ${
            (props) => (props.disabled ? css`color: lightgray;cursor: default;` : css`color: #cb0000;`)
        }
    }
    svg {
        font-size: 17px;
    }
`;

export const DownloadIconWrapper = styled.div`
    width: 20px;
    height: auto;
    cursor: pointer;
    padding-left: ${(props) => (props.pl ? props.pl : "0" )};
    padding-top: ${(props) => (props.pt ? props.pt : "0" )};
    color: #3b3b3b;
    ${
        (props) => (props.disabled ? css`color: lightgray;` : "")
    }
    &:hover {
        ${
            (props) => (props.disabled ? css`color: lightgray;cursor: default;` : css`color: #1076ff;`)
        }
    }
    svg {
        font-size: ${(props) => (props.fontSize ? props.fontSize : "17px" )};
    }
`;

export const ErrorMessage = styled.div`
    padding: 0px 10px 15px;
    color: #000;
    p {
        font-size: 13px;
        color: #292929;
    }
`;

export const ModelBodyDiv = styled.div`
padding: 10px;
    div[class*='CorrectAllError'] {
        top: 1px;
    }
`;

export const HeaderTitle = styled.div`
label {
    font-size: 14px;
    margin-bottom: 0;
    font-weight: 600;
    color: #484848;
}
`;

export const FooterButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 0px;
    button {
        width: 72px;
        background-color: #333;
        font-family: Verdana;
        font-size: 12px;
        margin-right: 10px;
        margin-left: 5px;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 23px;
    }
    button:hover {
        background-color: #000;
    }
    button.disabled {
        cursor: not-allowed;
    }
    button#cancel {
        margin-left: 0px;
        height:30px;
    }
    button#pply{
        height:30px;
    }
`;

export const EditActions = styled.div`
    display: flex;
    #cancel_button, #apply_button {
        height: 29px;
        ${props => (props.isOverwriteModel ? css`width: 165px;` : css`width: 105px;` )}
        color: #fff;
        text-transform: none;
        font-size: 1.1rem;
        font-family: Verdana;
        border-radius: 20px !important;
        padding: 16px 15px;
        white-space: nowrap !important;
    }
    #cancel_button {
        background-color: #eeeeee;
        margin-right: 20px;
        &:hover {
            background-color: #cccccc;
        }
        color: #181d1f;
    }
    #apply_button {
        background-color: #4c912d;
        &:hover {
            background-color: #467c26;
        }
    }
`;

export const FileUploadSpinner = styled.div`
    position: absolute;
    width: 70%;
    height: 95%;
    top: 0;
    z-index: 9999;
    div[class*='SpinnerDetails'] {
        width: 250px;
    }
`;

export const CertDetailsTable = styled.table`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
    tbody {
        tr {
            td:first-child {
                font-weight: 600;
                width: 200px;
                color: #333333;
            }
            td {
                height: 20px;
            }
        }
    }
`;

export const HyperLinkDiv = styled.div`
    cursor: pointer;
    color: #6890c6;
`;

export const HubParamModal = styled(Modal)`
    ${props => (props.fileUploadError ? css`max-width: 40%;margin-top: 9%;` : props.isOverwriteModel ? css`max-width: 45%;margin-top: 9%;` : "" )}
    ${props => (props.maxWidth ? css`max-width: ${props.maxWidth} !important;` : "" )}
    ${props => (props.mt ? css`margin-top: ${props.mt};` : "" )}
    > div {
        min-height: 280px;
        ${props => (props.fileUploadError ? css`border: 1px solid #808080; border-top: 7px solid #c20202;` 
        : css`border: 1px solid #808080;`)}
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 180px;` : null)}
        
    }
    #alert-content {
        margin-top: 21px;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
    }
    #import-file-error {
        margin-top: 20px;
        margin-left: 5px;
    }
    #import-file-error-message {
        color: #c20202;
        margin-left: 5px;
        margin-top: 10px;
    }
    #model-footer-section {
        justify-content: flex-end;
        margin-bottom: -8px;
        #cancel_button {
            ${props => (props.fileUploadError ? css`color: #181d1f; width: 95px;` : "")}
        }
    }
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #333;
            font-size: 1.4rem;
            display: flex;
            svg {
                ${props => (props.fileUploadError ? css`color: #c20202; margin-right: 10px;` : "")}
            }
        }
    }
`;

export const WarningModal = styled(Modal)`
  
    > div {
        min-height: 280px;
        ${props => (props.fileUploadError ? css`border: 1px solid #808080; border-top: 7px solid #c20202;` 
        : css`border: 1px solid #808080;`)}
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 160px;` : null)}
        
    }
    #alert-content {
        margin-top: 21px;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
    }
    #model-footer-section {
        margin-top: auto;
        justify-content: flex-end;
        #cancel_button {
            ${props => (props.fileUploadError ? css`color: #c20202; border: 1px solid #c20202; width: 115px;` : "")}
        }
    }
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
    }
`;

export const GenerateCSRModal = styled(Modal)`
.modal-content{
    width: 555px;
    border-top: 7px solid #61ae34;
}

.drHWjO{
    margin-right : 10px;
}

.fWKhvg {
    margin: 15px 5px 0 0;
    > #apply_button{
        height: 29px;
        ${props => (props.isOverwriteModel ? css`width: 90px;` : css`width: auto;` )}
        color: #fff;
        text-transform: none;
        font-size: 1.1rem;
        font-family: Verdana;
        border-radius: 20px !important;
        padding: 16px 15px;
        white-space: nowrap !important;
    }
}
    > div {
        min-height: 280px;
        border: 1px solid #808080;
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 160px; min-width: 30px` : null)}
    }

    #alert-content {
        margin: 18px 0 0 30px;
        font-size: 15px;
        line-height: 1.5;
    }

    #Success-alert-content {
        margin: 18px 0 0 10px;
        font-size: 15px;
        line-height: 1.5;
    }

    #alert-content > span {
        margin-left: 30px;
    }

    #model-footer-section {
        margin-top: auto;
        justify-content: flex-end;
        #cancel_button {
            ${props => (props.fileUploadError ? css`color: #c20202; border: 1px solid #c20202; width: 115px;` : "")}
        }
    }
   
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #61ae34;
            font-size: 1.4rem;
            display: flex;
        }

        span {
            color: #333;
            margin-left: 10px;
        }
    }
`;

export const ErrorModal = styled(Modal)`
.modal-content{
    width: 515px;
    border-top: 7px solid #c20202;
}
    > div {
        min-height: 280px;
        border: 1px solid #808080;
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 100px; min-width: 30px` : null)}
    }
   
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #c20202;
            font-size: 1.4rem;
            display: flex;
        }

        span {
            color: #333;
            margin-left: 10px;
        }
    }
    .HubValidation-lbl > span {
        font-family: Lato;
        font-size: 14px;
        line-height: 1.4285em;
    }
`;

export const ActionItemsContainer = styled(Col)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const HubStatusWarning = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    svg {
        margin-right: 5px;
        font-size: 18px;
        color: #f29d00;
    }
    p {
        color: #d88f06;
    }
`;

export const NextButton = styled(Button)`
    background-color: ${ props => (props.primary ? "#2070cf" :"#333333") } !important;
    border-color: ${ props => (props.primary ? "#61ae34" :"#333333") } !important;
    width: ${ props => (props.width ? props.width :"90px") };
    height: ${ props => (props.height ? props.height :"29px") };
    font-size: 13px !important;
    font-weight: normal !important;
    margin-left: ${ props => (props.ml ? props.ml :"5px") } !important;
    margin-right: ${ props => (props.mr ? props.mr :"5px") } !important;
    margin-top: ${ props => (props.mt ? props.mt :"5px") } !important;
    margin-bottom: ${ props => (props.mb ? props.mb :"5px") } !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    svg {
        margin-bottom: 2px;
        margin-right: 5px;
    };
    ${ props => (props.disabled ? css`
    background-color: ${ props => (props.primary ? "#2070cf" :"#bdbdbd") } !important;
    border-color: ${ props => (props.primary ? "#9ebd8b" :"#bdbdbd") } !important;
    opacity: ${ props => (props.primary ? "0.65" :"0") } !important;
    ` : null)
}
`;

export const EditNodeButton = styled(Button)`
    background-color: ${ props => (props.primary ? "#2070cf" :"#333333") } !important;
    border-color: ${ props => (props.primary ? "#61ae34" :"#333333") } !important;
    width: ${ props => (props.width ? props.width :"90px") };
    height: ${ props => (props.height ? props.height :"29px") };
    font-size: 13px !important;
    font-weight: normal !important;
    margin: ${ props => (props.ml ? props.ml :"5px 5px 5px 5px") } !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    svg {
        margin-bottom: 2px;
        margin-right: 5px;
    }
    ${(props) => props.disabled ? css`
    opacity: 0.65;
    display : none` : ""
    }
`;

export const GenCSRButton = styled(Button)`
    background-color: #333333 !important;
    color: #fff !important;
    height: 27px;
    font-size: 1rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    font-family: Verdana !important;
    margin-top: -13px !important;
    padding: 15px !important;
`;

export const Dropdown = styled.select`
font-size: 1rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    font-family: Verdana !important;
`;

export const EditNodeButtonContainer = styled.div`
    padding-left: 16px;
    border-color: ${ props => (props.primary ? "#61ae34" :"#333333") } !important;
    #button {
       padding: 6px 25px 7px 25px;
        color: #ffffff;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background-color: #333333;
        width: auto;
        height: 29px;
        text-transform: capitalize;
        margin-top: 4px;
        font-weight: 600;
        font-size: .9rem;
        font-family: Verdana;
        &:hover {
            background-color: #000000;
        }
        svg {
            margin-right: 3px;
            font-size: 12px;
        }
    }
    button#edit-button {
        background-color: #333333;
        color: #fff;
        &:hover {
            background-color: #000000;
        }
    }
`

export const BackButtonContainer = styled.div`
    padding-left: 16px;
    button {
        width: 90px;
        color: #fff;
        height: 29px;
        text-transform: capitalize;
        background-color: #eeeeee;
        color: #181d1f;
        border-radius: 4px !important;
        margin-top: 4px;
        font-size: 1.1rem;
        font-family: Verdana;
        padding: 16px 15px;
        &:hover {
            background-color: #cccccc;
        }
        svg {
            margin-right: 3px;
            font-size: 12px;
        }
    }
    button#edit-button {
        background-color: #2070cf;
        color: #fff;
        &:hover {
           opacity: 0.65
        }
    }
`;

export const ViewTableContainer = styled.div`
    /* border: 2px solid lightgray; */
    overflow: auto;
    width: 80%; // for larger desktop screens
    margin: 0px 30px 15px 10px;
    @media ${device.laptopL} {
        min-width: 90%;
    }
    @media ${device.laptopM} {
        min-width: 97%;
    }
    @media ${device.laptop} {
        min-width: 100%;
    }
    table {
        font-family: Verdana;
        tbody {
            tr {
                height: 45px;
                td {
                    color: #333333;
                    font-size: 1rem;
                    border: none;
                    white-space: nowrap;
                    padding: 0px 24px 0px 24px;
                    button {
                        width: 120px;
                        color: #1c1a1a;
                        height: 27px;
                        font-size: 12px;
                        text-transform: capitalize;
                        border: 1px solid #cccccc;
                        border-radius: 1px !important;
                    }
                    > label {
                        font-weight: 600;
                    }
                }
                td:first-child {
                    font-weight: 600;
                    /* font-size: 0.94rem; */
                }
            }
        }
    }
`;

export const EditTableContainer = styled.div`
    /* border: 2px solid lightgray; */
    margin: 20px;
    /* overflow: auto; */
    width: 70%;
    min-height: 75px;
    table {
        font-family: Verdana;
        tbody {
            tr {
                height: 45px;
                td {
                    color: #333333;
                    font-size: 1rem;
                    border: none;
                    white-space: nowrap;
                    padding: 0px 24px 0px 24px;
                }
                td:first-child {
                    font-weight: 600;
                    width: 275px;
                    /* font-size: 0.94rem; */
                }
            }
        }
    }
`;

export const TestConnectionModal = styled(Modal)`
> div {
    border: 1px solid #808080;
    border-radius: 5px !important;
    padding: 10px;
}   
#header-title {
    display: block;
    > div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    }   
    label {
        color: #333;
        font-family: Verdana;
        font-size: 1.4rem;
        display: flex;
        padding: 9px 7px 8px 7px;
    }
}
#body-content {
    padding: 10px 8px;
    text-align: center;
    font-family: Verdana;
    font-size: 1rem;
}
#model-footer-section{
    justify-content: flex-end;
}
`;
